import {Form, message, TreeSelect} from 'antd'
import {SDrawerOrModal, SGeneralForms} from "shj-components";
import {useSetState} from "ahooks";
import {useEffect} from "react";
import {employeePermissionsUpdate} from "@/services/saleOpServices.ts";
import {getChannelBrandAgent, getChannels} from "@/services/getUsers.ts";

export const AddOrEditRange = (props) => {
  const {openConfig, setOpen, record, reload} = props;
  const [form] = Form.useForm()
  const [state, setState] = useSetState({
    loading: false,
    channelIds: [],
    channelCategoryIds: [],
  })

  useEffect(() => {
    if (open && record.id) {
      console.log(record)
      const channelCategoryIds = record.channelCategoryIds ? record.channelCategoryIds : []
      const channelIds = record.channelIds ? record.channelIds : []
      form.setFieldsValue({
        ...record,
        channelIds: [...channelCategoryIds, ...channelIds]
      })
      setState({channelCategoryIds, channelIds })
    }
    return () => {
      form.resetFields()
    }
  }, [open, record]);

  const getOptions = async () => {
    const channels = await getChannels()
    const channelBrand = await getChannelBrandAgent()
    return Promise.resolve({channelBrand, channels})
  }

  const onChangeNode = (allCheckedNodes) => {
    console.log(allCheckedNodes)
    const resObj = {channelCategoryIds: [], channelIds: []}
    handleChannelData(allCheckedNodes, resObj)
    console.log(resObj)
    setState({...resObj})
  }

  const handleChannelData = (data, resObj) => {
    data.reduce((res, item) => {
      const nodeId = item.props?.id || item.node.props.id;
      if (item.children?.length > 0) {
        res.channelCategoryIds.push(nodeId)
        // handleChannelData(item.children, res)
      } else {
        res.channelIds.push(nodeId)
      }
      return res;
    }, resObj)
  }

  const onFinish = () => {
    form.validateFields().then(values => {
      setState({loading: true})
      employeePermissionsUpdate({
        ...values,
        channelIds: state.channelIds,
        channelCategoryIds: state.channelCategoryIds
      }).then(res => {
        message.success(res.message || '操作成功')
        reload()
        setOpen(false)
      }).finally(() => setState({loading: false}))
    })
  }

  return <SDrawerOrModal
      title={'配置范围'}
      open={openConfig}
      onCancel={() => setOpen(false)}
      loading={state.loading}
      onOk={onFinish}
      width={500}
      // mode={'modal'}
  >
    <SGeneralForms
        layout={'vertical'}
        formConfig={{form}}
        httpOptionsFn={getOptions}
        configs={[{
          formItem: [
            {label: 'id', name: 'id', hidden: true},
            {
              spanCol: 24,
              label: '渠道',
              name: 'channelIds',
              required: true,
              rules: [{required: true, message: '渠道不能为空'}],
              type: 'tree',
              data: 'channels',
              comConfig: {
                fieldNames: {value: 'id'},
                maxTagCount: 2,
                treeCheckable: true,
                showCheckedStrategy: TreeSelect.SHOW_PARENT,
                onChange: (v, l, {allCheckedNodes}) => onChangeNode(allCheckedNodes)
              }
            },
            {
              spanCol: 24,
              label: '品牌',
              name: 'brandIds',
              required: true,
              rules: [{required: true, message: '品牌不能为空'}],
              type: 'select',
              data: 'channelBrand',
              comConfig: {
                mode: 'multiple',
                maxTagCount: 2,
                fieldNames: {value: 'id', label: 'brandName'}
              }
            },
          ]
        }]}/>
  </SDrawerOrModal>
}
